//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('payCheckBatches', {
//        templateUrl: 'views/components/views/payCheckBatches/payCheckBatches.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'payCheckBatchesService', function (stateService, payCheckBatchesService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                setting: {},
//    			itemsListPayCheckBatches: []
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await payCheckBatchesService.getSetting())[0];
//            }

//            async function loadPayCheckBatches() {
//                vm.model.itemsListPayCheckBatches = await payCheckBatchesService.listPayCheckBatches();
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'paycheckbatch':
//                        go({ paycheckbatch_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadPayCheckBatches();
//            }

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
